import { withInstall } from '@vuemap/vue-amap-util'
import Flexible from './Flexible.vue'

export const ElAmapLayerFlexible = withInstall(Flexible)
export default ElAmapLayerFlexible
